package com.upcominds.expedite.dto

import kotlinx.serialization.Serializable

@Serializable
data class SocialChallengeConfigCreateRequest(
    val platform: String,
    val requiredTag: String,
    val minLikes: Int = 0,
    val minReposts: Int = 0
)

@Serializable
data class SocialChallengeConfigDTO(
    val platform: String,
    val requiredTag: String,
    val minLikes: Int,
    val minReposts: Int
)

@Serializable
data class SocialPostVerifyRequest(
    val postUrl: String
)

@Serializable
data class SocialChallengeSubmissionDTO(
    val id: String,
    val challengeId: String,
    val postUrl: String,
    val platform: String,
    val actualHandle: String? = null,
    val handleVerified: Boolean,
    val tagsFound: List<String>,
    val tagsMissing: List<String>,
    val likes: Int? = null,
    val reposts: Int? = null,
    val accepted: Boolean,
    val rejectionReason: String? = null,
    val submittedAt: String
)

@Serializable
data class SocialChallengeVerifyResultDTO(
    val submission: SocialChallengeSubmissionDTO,
    val completed: Boolean,
    val earnedPoints: Int
)
